<div class="container">
	<div class="trainer-toolbar">
		<button mat-flat-button color="primary" (click)="backToClass()" title="Back To Classes"
			style="font-size: 1rem; border-radius: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
			<i class="fa fa-arrow-left"></i> Back to Classes
		</button>
	</div>

	<div class="class-details-box">
		<p [innerHTML]="classDetails"></p>
	</div>

	<div class="status-tabs">
		<button class="tab-button" [class.active]="activeTab === 'templates'" (click)="setTab('templates')">
			<i class="fa fa-server"></i> Templates
		</button>
		<button class="tab-button" [class.active]="activeTab === 'userVMs'" (click)="setTab('userVMs')">
			<i class="fa fa-desktop"></i> User VMs
		</button>
		<button *ngIf="templateHasUserSubscription" class="tab-button" [class.active]="activeTab === 'userAccounts'" (click)="setTab('userAccounts')">
			<i class="fa fa-user"></i> User Accounts
		</button>
		<button class="tab-button" [class.active]="activeTab === 'costing'" (click)="setTab('costing')">
			<i class="fa fa-dollar-sign"></i> Costing
		</button>
		<button *ngIf="templateHasUserSubscription" class="tab-button" [class.active]="activeTab === 'subscriptionUsage'" (click)="setTab('subscriptionUsage')">
			<i class="fa fa-chart-pie"></i> Subscription Usage
		</button>
	</div>

	<div *ngIf="viewMode === 'detail'">
		<ng-container *ngIf="activeTab === 'templates'">
			<div class="class-card-list">
				<div class="class-card-header">
					<span>Id</span>
					<span>Type</span>
					<span>Name</span>
					<span>Subscription</span>
					<span>Resource Group</span>
					<span>VM Name</span>
					<span>Snapshot</span>
					<span>IP Address</span>
					<span class="action-header">Action</span>
				</div>
				<div class="class-card-row" *ngFor="let t of templates">
					<span [title]="t.id" [attr.data-has-tooltip]="t.id.length > 18 ? true : null">{{ t.id | slice:0:18
						}}{{ t.id.length > 18 ? '...' : '' }}</span>
					<span [title]="t.templateType" [attr.data-has-tooltip]="t.templateType.length > 18 ? true : null">{{
						t.templateType | slice:0:18 }}{{ t.templateType.length > 18 ? '...' : '' }}</span>
					<span [title]="t.templateName" [attr.data-has-tooltip]="t.templateName.length > 18 ? true : null">{{
						t.templateName | slice:0:18 }}{{ t.templateName.length > 18 ? '...' : '' }}</span>
					<span [title]="t.subscriptionId"
						[attr.data-has-tooltip]="t.subscriptionId?.length > 18 ? true : null">{{ t.subscriptionId |
						slice:0:18 }}{{ t.subscriptionId?.length > 18 ? '...' : '' }}</span>
					<span [title]="t.resourceGroup"
						[attr.data-has-tooltip]="t.resourceGroup?.length > 18 ? true : null">{{ t.resourceGroup |
						slice:0:18 }}{{ t.resourceGroup?.length > 18 ? '...' : '' }}</span>
					<span [title]="t.vmName" [attr.data-has-tooltip]="t.vmName?.length > 18 ? true : null">{{ t.vmName |
						slice:0:18 }}{{ t.vmName?.length > 18 ? '...' : '' }}</span>
					<span [title]="t.snapshotName"
						[attr.data-has-tooltip]="t.snapshotName?.length > 18 ? true : null">{{
						t.snapshotName | slice:0:18 }}{{ t.snapshotName?.length > 18 ? '...' : '' }}</span>
					<span [title]="t.publicIPAddress"
						[attr.data-has-tooltip]="t.publicIPAddress?.length > 18 ? true : null">{{ t.publicIPAddress |
						slice:0:18 }}{{ t.publicIPAddress?.length > 18 ? '...' : '' }}</span>
					<div class="actions ellipsis-menu-wrapper" style="position: relative;">
						<button class="icon-button ellipsis-btn" title="More actions" (click)="toggleMenu(t, $event)">
							<i class="fa fa-ellipsis-v"></i>
						</button>
						<div class="ellipsis-dropdown" *ngIf="openedMenu == t.id" (click)="$event.stopPropagation()">
							<button *ngIf="isVisibleLaunchButton" class="dropdown-item" (click)="launchTemplate(t); closeMenu()">
								<i class="fa fa-desktop menu-icon" aria-hidden="true"></i>
								Launch
							</button>
							<button *ngIf="false" class="dropdown-item" (click)="createSnapshot(t); closeMenu()">
								<i class="fa fa-camera menu-icon" aria-hidden="true"></i>
								Create snapshot
							</button>
							<!-- *ngIf="isVisibleDeteleResourceButton" -->
							<button *ngIf="isVisibleDeleteButton"  class="dropdown-item delete" (click)="deleteTemplate(t); closeMenu()">
								<i class="fa fa-trash menu-icon" aria-hidden="true"></i>
								Delete
							</button>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="activeTab === 'userVMs'">
			<!-- Manage All VMs Dropdown -->
			<div *ngIf="isVisibleDeteleResourceButton" class="action-toolbar-compact">
				<div class="dropdown manage-all-dropdown">
					<button mat-stroked-button type="button"
					        (click)="toggleManageAllMenu($event)">
						<i class="fa fa-cog"></i> Manage All VMs
					</button>
					<ul class="dropdown-menu dropdown-menu-end" [class.show]="manageAllMenuOpen">
						<li>
							<a class="dropdown-item" href="javascript:void(0)" (click)="shutdownAllVMs()">
								<i class="fa fa-power-off text-warning"></i> Shutdown All
								<small class="text-muted" style="display:block">Graceful OS power-off · charges continue</small>
							</a>
						</li>
						<li>
							<a class="dropdown-item" href="javascript:void(0)" (click)="deallocateAllVMs()">
								<i class="fa fa-stop-circle text-warning"></i> Deallocate All
								<small class="text-muted" style="display:block">Hard-stop + release compute · no OS signal</small>
							</a>
						</li>
						<li>
							<a class="dropdown-item" href="javascript:void(0)" (click)="shutdownAndDeallocateAllVMs()">
								<i class="fa fa-stop text-warning"></i> Shutdown &amp; Deallocate All
								<small class="text-muted" style="display:block">Graceful shutdown then deallocate · charges pause</small>
							</a>
						</li>
						<li><hr class="dropdown-divider"></li>
						<li>
							<a class="dropdown-item text-danger" href="javascript:void(0)" (click)="destroyAllResources()">
								<i class="fa fa-trash"></i> Destroy All VMs
								<small style="display:block">Permanent deletion · irreversible</small>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div class="class-card-list">
				<div class="class-card-header">
					<span>Participant</span>
					<span>Invite Email</span>
					<span>Redeem Email</span>
					<span>OS Disk</span>
					<span>Subscription</span>
					<span>Resource Group</span>
					<span>VM Name</span>
					<span>IP Address</span>
					<span class="action-header">Action</span>
				</div>
				<div class="class-card-row" *ngFor="let vm of userVMs">
					<span [title]="vm.participant" [attr.data-has-tooltip]="vm.participant.length > 18 ? true : null">{{
						vm.participant | slice:0:18 }}{{ vm.participant.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.inviteEmail" [attr.data-has-tooltip]="vm.inviteEmail.length > 18 ? true : null">{{
						vm.inviteEmail | slice:0:18 }}{{ vm.inviteEmail.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.redeemEmail" [attr.data-has-tooltip]="vm.redeemEmail.length > 18 ? true : null">{{
						vm.redeemEmail | slice:0:18 }}{{ vm.redeemEmail.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.osDiskName" [attr.data-has-tooltip]="vm.osDiskName.length > 18 ? true : null">{{
						vm.osDiskName | slice:0:18 }}{{ vm.osDiskName.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.subscriptionId"
						[attr.data-has-tooltip]="vm.subscriptionId.length > 18 ? true : null">{{ vm.subscriptionId |
						slice:0:18 }}{{ vm.subscriptionId.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.resourceGroupName"
						[attr.data-has-tooltip]="vm.resourceGroupName.length > 18 ? true : null">{{ vm.resourceGroupName
						| slice:0:18 }}{{ vm.resourceGroupName.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.vmName" [attr.data-has-tooltip]="vm.vmName.length > 18 ? true : null">{{ vm.vmName
						| slice:0:18 }}{{ vm.vmName.length > 18 ? '...' : '' }}</span>
					<span [title]="vm.publicIpAddress"
						[attr.data-has-tooltip]="vm.publicIpAddress.length > 18 ? true : null">{{ vm.publicIpAddress |
						slice:0:18 }}{{ vm.publicIpAddress.length > 18 ? '...' : '' }}</span>
					<span class="actions">
						<div class="dropdown vm-row-menu">
							<button class="icon-button" title="Actions" (click)="toggleVMMenu(vm, $event)">
								<i class="fa fa-ellipsis-v"></i>
							</button>
							<ul class="dropdown-menu dropdown-menu-end" [class.show]="openedVMMenu === vm.userId">
								<li>
									<a class="dropdown-item" href="javascript:void(0)" (click)="viewVMDetails(vm)">
										<i class="fa fa-eye"></i> View Details
									</a>
								</li>
								<li *ngIf="isVisibleDeteleResourceButton">
									<a class="dropdown-item" href="javascript:void(0)" (click)="shutdownVM(vm)">
										<i class="fa fa-power-off text-warning"></i> Shutdown
									</a>
								</li>
								<li *ngIf="isVisibleDeteleResourceButton">
									<a class="dropdown-item" href="javascript:void(0)" (click)="deallocateVM(vm)">
										<i class="fa fa-stop-circle text-warning"></i> Deallocate
									</a>
								</li>
								<li *ngIf="isVisibleDeteleResourceButton">
									<a class="dropdown-item" href="javascript:void(0)" (click)="shutdownAndDeallocateVM(vm)">
										<i class="fa fa-stop text-warning"></i> Shutdown &amp; Deallocate
									</a>
								</li>
								<li *ngIf="isVisibleDeteleResourceButton"><hr class="dropdown-divider"></li>
								<li *ngIf="isVisibleDeteleResourceButton">
									<a class="dropdown-item text-danger" href="javascript:void(0)" (click)="destroyVM(vm); closeVMMenu()">
										<i class="fa fa-trash"></i> Destroy
									</a>
								</li>
							</ul>
						</div>
					</span>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="activeTab === 'userAccounts' && templateHasUserSubscription">
			<!-- Destroy All Accounts Link -->
			<div *ngIf="isVisibleDeteleResourceButton" class="action-toolbar-compact">
				<a href="javascript:void(0)"
				   class="destroy-all-link"
				   (click)="destroyAllAccounts()"
				   title="Destroy all user accounts and related resources">
					<i class="fa fa-user-times"></i> Destroy All Accounts
				</a>
			</div>

			<div class="class-card-list">
				<div class="class-card-header">
					<span>Participant</span>
					<span>Invite Email</span>
					<span>Redeem Email</span>
					<span>Cloud Username</span>
					<span>Cloud Password</span>
					<span>Subscription</span>
					<span>Description</span>
					<span class="action-header">Action</span>
				</div>
				<div class="class-card-row" *ngFor="let acc of userAccounts">
					<span [title]="acc.participant"
						[attr.data-has-tooltip]="acc.participant.length > 18 ? true : null">{{ acc.participant |
						slice:0:18 }}{{ acc.participant.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.inviteEmail"
						[attr.data-has-tooltip]="acc.inviteEmail.length > 18 ? true : null">{{ acc.inviteEmail |
						slice:0:18 }}{{ acc.inviteEmail.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.redeemEmail"
						[attr.data-has-tooltip]="acc.redeemEmail.length > 18 ? true : null">{{ acc.redeemEmail |
						slice:0:18 }}{{ acc.redeemEmail.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.cloudeUsername"
						[attr.data-has-tooltip]="acc.cloudeUsername.length > 18 ? true : null">{{ acc.cloudeUsername |
						slice:0:18 }}{{ acc.cloudeUsername.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.cLoudePassword"
						[attr.data-has-tooltip]="acc.cLoudePassword.length > 18 ? true : null">{{ acc.cLoudePassword |
						slice:0:18 }}{{ acc.cLoudePassword.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.subscriptionId"
						[attr.data-has-tooltip]="acc.subscriptionId.length > 18 ? true : null">{{ acc.subscriptionId |
						slice:0:18 }}{{ acc.subscriptionId.length > 18 ? '...' : '' }}</span>
					<span [title]="acc.description"
						[attr.data-has-tooltip]="acc.description.length > 18 ? true : null">{{ acc.description |
						slice:0:18 }}{{ acc.description.length > 18 ? '...' : '' }}</span>
					<span class="actions">
						<button class="icon-button" title="View Details" (click)="viewAccountDetails(acc)"><i
								class="fa fa-eye"></i></button>
						<button *ngIf="isVisibleDeteleResourceButton" class="icon-button" title="Destroy" (click)="destroyAccount(acc)"><i
								class="fa fa-trash"></i></button>
					</span>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="activeTab === 'costing'">
			<div class="costing-container">
				<div class="costing-header">
					<h3>Cost Analysis</h3>
					<div class="total-cost">
						<span class="total-label">Total Cost: </span>
						<span class="total-amount">₹{{ getTotalCost().toFixed(2) }}</span>
					</div>
					<button class="refresh-btn" (click)="getCostingData()">
						<i class="fa fa-refresh"></i> Refresh Data
					</button>
				</div>

				<div class="costing-content">
					<!-- Subscriptions List -->
					<div class="subscriptions-panel">
						<h4>Subscriptions</h4>
						<div class="subscription-list">
							<div
								*ngFor="let subscription of subscriptions"
								class="subscription-item"
								[class.selected]="selectedSubscription?.subscriptionId === subscription.subscriptionId"
								(click)="selectSubscription(subscription)">
								<div class="subscription-header">
									<span class="subscription-id">{{ subscription.subscriptionId }}</span>
									<span class="subscription-type">{{ subscription.subscriptionType }}</span>
								</div>
								<div class="subscription-details">
									<div class="cost-info">
										<span class="cost-amount">₹{{ subscription.totalCostINR.toFixed(2) }}</span>
										<span class="cost-currency">({{ subscription.originalCurrency }})</span>
									</div>
									<div class="resource-count">
										{{ subscription.resourceCount }} resources
									</div>
									<div class="timeframe">
										{{ subscription.timeframe }} - {{ subscription.asOfUtc | date:'short' }}
									</div>
								</div>
							</div>

							<!-- <div *ngIf="subscriptions.length === 0" class="no-data">
								<p>No subscription data available</p>
								<button class="refresh-btn" (click)="getCostingData()">Load Costing Data</button>
							</div> -->
						</div>
					</div>

					<!-- Resources Details -->
					<div class="resources-panel">
						<h4>
							Resource Details
							<span *ngIf="selectedSubscription">({{ selectedSubscription.subscriptionId }})</span>
						</h4>

						<div *ngIf="selectedSubscription" class="resources-table-container">
							<table class="resources-table">
								<thead>
									<tr>
										<th>Resource Type</th>
										<th>Resource Name</th>
										<th>Cost (₹)</th>
										<th>Participant</th>
										<th>Username</th>
										<th>Redemption Key</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let resource of selectedResources">
										<td>
											<span class="resource-type-badge" [attr.data-type]="getResourceTypeLabel(resource.resourceId)">
												{{ getResourceTypeLabel(resource.resourceId) }}
											</span>
										</td>
										<td class="resource-name">{{ resource.name }}</td>
										<td class="cost-cell">₹{{ parseFloat(resource.costInINR).toFixed(2) }}</td>
										<td>{{ resource.participantEmailId }}</td>
										<td>{{ resource.username }}</td>
										<td class="redemption-key">{{ resource.redemptionKey }}</td>
									</tr>
								</tbody>
							</table>

							<div *ngIf="selectedResources.length === 0" class="no-resources">
								<p>No resources found for this subscription</p>
							</div>
						</div>

						<div *ngIf="!selectedSubscription" class="no-selection">
							<p>Select a subscription to view resource details</p>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="activeTab === 'subscriptionUsage' && templateHasUserSubscription">
			<div class="subscription-usage-container">
				<!-- Header with Total Usage Summary -->
				<div class="subscription-usage-header">
					<div class="header-content">
						<h3><i class="fa fa-chart-pie"></i> Subscription Usage Overview</h3>
						<div class="usage-stats">
							<div class="stat-card total">
								<div class="stat-label">Total Quota</div>
								<div class="stat-value">${{ totalUsage.totalQuota }}</div>
							</div>
							<div class="stat-card used">
								<div class="stat-label">Total Used</div>
								<div class="stat-value">${{ totalUsage.totalUsed }}</div>
							</div>
							<div class="stat-card remaining">
								<div class="stat-label">Remaining</div>
								<div class="stat-value">${{ totalUsage.remainingQuota }}</div>
							</div>
							<div class="stat-card percentage">
								<div class="stat-label">Utilization</div>
								<div class="stat-value">{{ totalUsage.utilizationPercentage }}%</div>
							</div>
						</div>
					</div>
				</div>

				<div class="subscription-usage-content">
					<!-- Left Panel: User List -->
					<div class="users-panel">
						<h4><i class="fa fa-users"></i> Students</h4>
						<div class="user-list">
							<div
								class="user-card"
								*ngFor="let user of userWiseUsage"
								[class.selected]="selectedUser?.userId === user.userId"
								(click)="selectUser(user)">
								<div class="user-card-header">
									<div class="user-info">
										<div class="user-avatar">{{ user.userName.charAt(0) }}</div>
										<div class="user-details">
											<div class="user-name">{{ user.userName }}</div>
											<div class="user-email">{{ user.email }}</div>
										</div>
									</div>
								</div>
								<div class="user-card-body">
									<div class="usage-bar-container">
										<div class="usage-bar">
											<div
												class="usage-bar-fill"
												[style.width.%]="(user.used / user.quota) * 100"
												[class.high-usage]="(user.used / user.quota) > 0.8"
												[class.medium-usage]="(user.used / user.quota) > 0.5 && (user.used / user.quota) <= 0.8">
											</div>
										</div>
										<div class="usage-text">
											<span class="used-amount">${{ user.used }}</span> /
											<span class="quota-amount">${{ user.quota }}</span>
										</div>
									</div>
									<div class="resource-summary">
										<i class="fa fa-box"></i> {{ user.resources.length }} Resources
									</div>
								</div>
							</div>

							<div *ngIf="userWiseUsage.length === 0" class="no-data">
								<i class="fa fa-inbox"></i>
								<p>No users found</p>
							</div>
						</div>
					</div>

					<!-- Right Panel: User Resources Details -->
					<div class="resources-detail-panel">
						<h4>
							<i class="fa fa-server"></i> Resource Details
							<span *ngIf="selectedUser" class="selected-user-badge">{{ selectedUser.userName }}</span>
						</h4>

						<div *ngIf="selectedUser" class="resources-table-wrapper">
							<table class="resources-detail-table">
								<thead>
									<tr>
										<th>Resource Name</th>
										<th>Type</th>
										<th>Cost</th>
										<th>Status</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let resource of userWiseResources">
										<td class="resource-name-cell">
											<i class="fa fa-circle resource-icon"
											   [class.vm-icon]="resource.type === 'Virtual Machine'"
											   [class.db-icon]="resource.type === 'Database'"
											   [class.app-icon]="resource.type === 'App Service'"
											   [class.storage-icon]="resource.type === 'Storage'"></i>
											{{ resource.name }}
										</td>
										<td>
											<span class="resource-type-badge" [attr.data-type]="resource.type">
												{{ resource.type }}
											</span>
										</td>
										<td class="cost-cell">${{ resource.cost }}</td>
										<td>
											<span class="status-badge" [class.status-running]="resource.status === 'Running'">
												{{ resource.status }}
											</span>
										</td>
									</tr>
								</tbody>
								<tfoot *ngIf="userWiseResources.length > 0">
									<tr>
										<td colspan="2" class="total-label"><strong>Total Cost:</strong></td>
										<td colspan="2" class="total-cost">
											<strong>${{ selectedUser.used }}</strong>
										</td>
									</tr>
								</tfoot>
							</table>

							<div *ngIf="userWiseResources.length === 0" class="no-resources">
								<i class="fa fa-inbox"></i>
								<p>No resources found for this user</p>
							</div>
						</div>

						<div *ngIf="!selectedUser" class="no-selection">
							<i class="fa fa-hand-pointer"></i>
							<p>Select a student to view their resource details</p>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<ng-container *ngIf="viewMode === 'card'">
		<div class="class-card-grid">
			<div *ngIf="activeTab === 'templates'">
				<div class="class-card" *ngFor="let t of templates">
					<div class="card-header">
						<div class="avatar">{{ t.templateName[0] }}</div>
						<span class="status-badge">{{ t.templateType }}</span>
					</div>
					<div class="card-body">
						<h3 class="class-name">{{ t.templateName }}</h3>
						<p class="class-id">ID: {{ t.id }}</p>
						<div class="info-section">
							<p class="info-line"><strong>Subscription:</strong> {{ t.subscriptionId }}</p>
							<p class="info-line"><strong>Resource Group:</strong> {{ t.resourceGroup }}</p>
							<p class="info-line"><strong>VM Name:</strong> {{ t.vmName }}</p>
							<p class="info-line"><strong>Snapshot:</strong> {{ t.snapshotName }}</p>
							<p class="info-line"><strong>IP Address:</strong> {{ t.publicIPAddress }}</p>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="activeTab === 'userVMs'">
				<div class="class-card" *ngFor="let vm of userVMs">
					<div class="card-header">
						<div class="avatar">{{ vm.participant[0] }}</div>
						<span class="status-badge">VM</span>
					</div>
					<div class="card-body">
						<h3 class="class-name">{{ vm.vmName }}</h3>
						<p class="class-id">ID: {{ vm.osDiskName }}</p>
						<div class="info-section">
							<p class="info-line"><strong>Participant:</strong> {{ vm.participant }}</p>
							<p class="info-line"><strong>Invite Email:</strong> {{ vm.inviteEmail }}</p>
							<p class="info-line"><strong>Redeem Email:</strong> {{ vm.redeemEmail }}</p>
							<p class="info-line"><strong>Subscription:</strong> {{ vm.subscriptionId }}</p>
							<p class="info-line"><strong>Resource Group:</strong> {{ vm.resourceGroupName }}</p>
							<p class="info-line"><strong>IP Address:</strong> {{ vm.publicIpAddress }}</p>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="activeTab === 'userAccounts'">
				<div class="class-card-list">
					<div class="class-card-header">
						<span>Participant</span>
						<span>Invite Email</span>
						<span>Redeem Email</span>
						<span>Cloud Username</span>
						<span>Cloud Password</span>
						<span>Subscription</span>
						<span>Description</span>
					</div>
					<div class="class-card-row" *ngFor="let acc of userAccounts">
						<span>{{ acc.participant }}</span>
						<span>{{ acc.inviteEmail }}</span>
						<span>{{ acc.redeemEmail }}</span>
						<span>{{ acc.cloudeUsername }}</span>
						<span>{{ acc.cLoudePassword }}</span>
						<span>{{ acc.subscriptionId }}</span>
						<span>{{ acc.description }}</span>
					</div>
				</div>
				</div>
		</div>
	</ng-container>
</div>
